import { useSelector } from "react-redux";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import { selectUserData } from "../../../../features/userSlice";
import Page404 from "../../../../components/Page404/Page403";
import BrandProperties from "../../../../components/Partners/DataIntegrations/Brands/BrandProperties/BrandProperties";

// Edit Properties, reached from the Brands module's "Automatic Configure"
// quick action (operations/brands/edit_properties). BrandProperties now
// lives under this module's own folder (moved, not duplicated, from the
// legacy DataIntegrations/BrandProperties location) — its own screen/route
// (BrandPropertiesScreen.tsx, operations/brand_configuration_report/brand_properties)
// still imports it from its new location and is otherwise untouched.
const EditPropertiesScreen = () => {
  const userData = useSelector(selectUserData);
  const hasBrandsPermission = CheckPermissions(
    userData?.data?.products?.data_collection,
    "brands",
    "view_brands",
  );

  return <>{hasBrandsPermission ? <BrandProperties /> : <Page404 />}</>;
};

export default EditPropertiesScreen;
